import Container from './TierLayout.container';
import TierLayout from './TierLayout';

export default Container(TierLayout);
